/**
 * Seed.Menu
 */

define('Seed.Menu',['jquery', 'Seed', 'Seed.Tab'], function ($, Seed) {
    'use strict';

    Seed.Menu = {
        /**
         * Afficher le module
         *
         * @param pModuleName
         *            Nom du module a afficher
         * @param pTitre
         *            Titre de l'onglet
         */
        ShowModule: function (pModuleName, pTitre, isDefaultAction) {
            // Noter le module actif comme ouvert
            $('#tdmainmenu>li.Seed_Menu_Active').addClass('Seed_Menu_Opened');
            // Cacher les modules
            $('#tdmainmenu > li').removeClass("Seed_Menu_Active active");
            // Afficher le module activé
            $("#" + pModuleName + "_link")
                    .addClass("Seed_Menu_Active active Seed_Menu_Opened");
            //// Cacher le menu
            //Seed.Menu.HideMenu(pModuleName);
            // Afficher l'écran
            Seed.Tab.ShowModule(pModuleName, pTitre, isDefaultAction);
        },
        /**
         * Supprimer le module à l'affichage
         *
         * @param pModuleName
         *            Nom du module à supprimer
         */
        Clear: function (pModuleName) {
            while ($('#' + pModuleName + '_tab').length !== 0) {
                $('#' + pModuleName + '_tab').remove();
//                Seed.Tab.Close(pModuleName);
            }

            $("#" + pModuleName + "_frame").remove();
            Seed.Tab.aActive[pModuleName] = null;
        }

    };
});

